import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduce, indexOf } from 'lodash';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import OwnerCell from '../../../../components/owner-cell';

class LabelCellRenderer extends Component {
  constructor(args) {
    super(args);
    this.state = {};
  }

  getExcluded() {
    const {
      context: { mappings },
      data: { value },
    } = this.props;
    const v = reduce(mappings, (itm, mapping) => {
      const indx = indexOf(mapping.values, value);
      if (indx >= 0) {
        return true;
      }
      return itm || false;
    }, false);
    return !v;
  }

  renderContent() {
    const {
      value, data, showStar,
      isUserMapping,
    } = this.props;
    if (!data) {
      return null;
    }
    const { description } = data;
    const excluded = this.getExcluded();
    const isUserRow = isUserMapping === true;
    const hasPopover = isUserRow || (description !== null && description !== undefined && description.length > 0);

    const popover = hasPopover ? (
      <Popover id={`description-${data._id}`} title={isUserRow ? null : value}>
        <div>
          {!isUserRow && <div>{description}</div>}
          {isUserRow && <OwnerCell owner={data} showFullEmail />}
        </div>
      </Popover>
    ) : null;

    const isActive = data.is_active === true;

    const activeTooltip = (
      <Tooltip id={`active-tooltip-${data._id}`}>{isActive ? 'Active' : 'Inactive'}</Tooltip>
    );

    const displatLabel = excluded ? (<span>{value}</span>) : (<strong>{value}</strong>);

    return (
      <div>
        <table>
          <tbody>
            <tr>
              {showStar &&
                <td>
                  <OverlayTrigger placement="right" overlay={activeTooltip}>
                    <Fa name={isActive ? 'star' : 'star-o'} className={isActive ? 'text-warning' : 'text-muted'} />
                  </OverlayTrigger>
                  &nbsp;&nbsp;
                </td>
              }
              <td>
                {displatLabel}
                {popover !== null &&
                  <span>&nbsp;
                    <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popover}>
                      <Fa name="info-circle" style={{ cursor: 'pointer' }} className="text-active" />
                    </OverlayTrigger>
                  </span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!this.props.data) {
      return null;
    }
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}


LabelCellRenderer.propTypes = {
  value: PropTypes.string,
  showStar: PropTypes.bool,
  data: PropTypes.shape({
    _id: PropTypes.string,
    description: PropTypes.string,
    excluded: PropTypes.bool,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  context: PropTypes.shape({
    mappings: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  isProductFamily: PropTypes.bool,
  isUserMapping: PropTypes.bool,
};

LabelCellRenderer.defaultProps = {
  value: null,
  data: null,
  showStar: true,
  isProductFamily: false,
  isUserMapping: false,
};

export default LabelCellRenderer;
